var headerHomepageJs = (function () {
  return {
    init: init,
  };

  function init() {
    var headerHabitat = document.querySelector('.header-habitat');
    //check header habitat Menu html exists
    if (headerHabitat && headerHabitat.innerHTML.length > 0) {
      uiBindings();
    }
  }

  function uiBindings() {
    /**
     * Instrumentation
     */
    var navLinks = document.querySelectorAll(
      '.bstack-mm-logo, .bstack-mm-link, .bstack-mm-btn, .bstack-mm-sub-nav-tab'
    );
    if (navLinks) {
      for (var idx = 0; idx < navLinks.length; idx++) {
        navLinks[idx].addEventListener(
          'click',
          function () {
            headerTrackingEvents(this, true);
          },
          false
        );
      }
    }
  }

  function headerTrackingEvents(that, urlExists) {
    var pageSlug = window.location.pathname,
      pageSlug = pageSlug.replace(/^\/|\/$/g, ''),
      eventName,
      eventObj = {
        action:
          (that.getAttribute('title') ? that.getAttribute('title') : that.getAttribute('aria-label')) +
          ' Main Navigation',
        location: 'Primary Header',
        group: that.getAttribute('title'),
        referrer: document.referrer,
        properties_source: getHeaderProsfromURL(pageSlug),
      };

    if (pageSlug == 'live') {
      eventName = 'InteractedWithLiveMarketingPage';
    } else if (pageSlug == 'automate') {
      eventName = 'InteractedWithAutomateMarketingPage';
    } else if (pageSlug == 'app-live') {
      eventName = 'InteractedWithAppLiveMarketingPage';
    } else if (pageSlug == 'app-automate') {
      eventName = 'InteractedWithAppAutomateMarketingPage';
    } else if (pageSlug == 'percy') {
      eventName = 'InteractedWithPercyMarketingPage';
    } else if (pageSlug == '') {
      eventName = 'InteractedWithHomePage';
    }

    if (urlExists) {
      eventObj.properties_destination = getHeaderProsfromURL(that.getAttribute('href'));
    }

    if (popUpCSFOptions.vwoShow) {
      eventObj.source = popUpCSFOptions.source;
    }

    //group updated
    if (that.closest('.bstack-mm-products-nav')) {
      eventObj.group = 'Product';
      if (that.closest('#products-dd-tabpanel-1') || that.getAttribute('id') == 'products-dd-tab-1') {
        eventObj.group = 'Product Web Testing';
      } else if (that.closest('#products-dd-tabpanel-2') || that.getAttribute('id') == 'products-dd-tab-2') {
        eventObj.group = 'Product App Testing';
      }
    } else if (that.closest('.bstack-mm-developers-nav')) {
      eventObj.group = 'Developers';
    }

    if (window.hasOwnProperty('WebEventTracker')) {
      WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
    }
  }

  function getHeaderProsfromURL(url) {
    var txt = '',
      //regex for check URL with domain name
      regex = new RegExp(
        '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
      );

    //check url has domain name
    if (regex.test(url)) {
      var hostName = url.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0];

      //check url contain browserstack.com
      if (hostName === 'browserstack.com') {
        url = url.substring(url.indexOf(hostName) + hostName.length + 1, url.length);
      } else {
        url = hostName;
      }
    }

    if (!url || url.length === 0) {
      return '';
    }

    var URLArr = url.replace(/^\/|\/$/g, '').split('/');

    if (URLArr.length >= 2) {
      txt = URLArr[0].replaceAll('-', ' ') + ' ' + URLArr[1].replaceAll('-', ' ') + ' page';
    } else {
      txt = URLArr[0].replaceAll('-', ' ');
    }

    //check homepage
    txt = txt.length == 0 ? 'Home page' : txt;

    return txt;
  }
})();

headerHomepageJs.init();
